// eslint-disable-next-line jira/restricted/react-component-props
import type { ComponentProps } from 'react';
import { Popper } from '@atlaskit/popper';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';

export const ChoreographerPopper = withChoreographedRender<ComponentProps<typeof Popper>>(Popper);
